import { render, staticRenderFns } from "./universityExploration.vue?vue&type=template&id=04ed6a04&scoped=true"
import script from "./universityExploration.vue?vue&type=script&lang=js"
export * from "./universityExploration.vue?vue&type=script&lang=js"
import style0 from "./universityExploration.vue?vue&type=style&index=0&id=04ed6a04&prod&scoped=true&lang=less"
import style1 from "./universityExploration.vue?vue&type=style&index=1&id=04ed6a04&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ed6a04",
  null
  
)

export default component.exports